import { render } from "./Disabled.vue?vue&type=template&id=35165952&scoped=true"
const script = {}

import "./Disabled.vue?vue&type=style&index=0&id=35165952&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35165952"]])

export default __exports__